import s3PresignedUrl from './s3PresignedUrl'
import { DOCUMENTS } from '../constants/paths'
import { capitalizeEachWord } from './stringOperations'
import Cookies from 'universal-cookie'

export const saveSignedCookie = (cookie) => {
    const cookies = new Cookies()
    let d = new Date()
    d.setTime(d.getTime() + 60 * 60 * 1000)

    const parsedCookie = cookie.replace(/"/g, '').split(',')
    cookies.set('CloudFront-Policy', parsedCookie[0].split(':')[1], {
        path: '/',
        expires: d,
        domain: 'bssnet.com',
        secure: true,
        httpOnly: true,
        sameSite: true,
    })
    cookies.set('CloudFront-Key-Pair-Id', parsedCookie[1].split(':')[1], {
        path: '/',
        expires: d,
        domain: 'bssnet.com',
        secure: true,
        httpOnly: true,
        sameSite: true,
    })
    cookies.set('CloudFront-Signature', parsedCookie[2].split(':')[1], {
        path: '/',
        expires: d,
        domain: 'bssnet.com',
        secure: true,
        httpOnly: true,
        sameSite: true,
    })
}

export const formatPhoneNumber = (phoneNumberString) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        return ['+1', match[2], match[3], match[4]].join('')
    }
    return null
}

export const formatRole = (role) => {
    if(role.includes('-')) return role
    return capitalizeEachWord(role.replace(/[^a-zA-Z0-9]/g, ' '))
}

export const formatPhoneNumberToUS = (phoneNumberString) => {
    let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
    let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (match) {
        return ['(', match[2], ') ', match[3], '-', match[4]].join('')
    }
    return null
}

export const numberWithCommas = (x) => {
    return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
}

export const b64EncodeUnicode = (str) => {
    return btoa(
        encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function toSolidByte(match, p1) {
            return String.fromCharCode('0x' + p1)
        })
    )
}

export const truncateString = (str, num) => {
    return str.length > num ? str.slice(0, num) + '...' : str
}

export const getInitials = (name) => {
    return name.match(/\b\w/g).join('')
}

export const parsePlace = (place) => {
    place = place || {}

    const byType = (place.address_components || []).reduce(function (acc, data) {
        data.types.forEach(function (type) {
            acc[type] = data
        })
        return acc
    }, {})

    const result = {
        streetNumber: placeGet('street_number'),
        streetName: placeGet('route'),
        city:
            placeGet('locality') ||
            placeGet('sublocality') ||
            placeGet('sublocality_level_1') ||
            placeGet('neighborhood') ||
            placeGet('administrative_area_level_3') ||
            placeGet('administrative_area_level_2'),
        state: placeGet('administrative_area_level_1', true),
        country: placeGet('country', true),
        zipCode: placeGet('postal_code'),
    }

    result.street = [result.streetNumber, result.streetName].filter(Boolean).join(' ')

    return result

    function placeGet(key, short) {
        if (!(key in byType)) return ''

        return short ? byType[key].short_name : byType[key].long_name
    }
}

export const formatAddress = (address) => {
    return address ? `${address.street}, ${address.city}, ${address.state} ${address.zipCode}` : ''
}

export const addressObjectToString = (obj) => {
    let str = ''
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            if (obj[p] !== null && obj[p] !== '') str += obj[p] + ', '
        }
    }
    return str
}

const generateSignedUrl = (file, cb) => s3PresignedUrl(DOCUMENTS, file, cb)

export const getFile = (building, key) => {
    return new Promise((resolve, reject) => {
        generateSignedUrl(`${building}/${key}`, (err, url) => {
            if (err) {
                reject(err)
            }
            resolve(url)
        })
    })
}

export const isModuleEnabled = (modules, module) => {
    if(!modules) return false
    let mod = modules.find((m) => m.key === module)
    if ((mod && mod.enabled) || mod == null) return true
}
